export default __webpack_public_path__ + "static/1528-be1342415e7784f6058aad0d3c1917ad.gif";